import _ from 'lodash';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getSelectedTerm } from '../actions';

////////////////////////////////////////////////////
// The converted Flash animations were all created
// with createjs, which seems to auto-generate an
// HTML template and a js file by default.
// The animation panel is simply an iFrame that
// loads the relevant HTML file.
////////////////////////////////////////////////////
class Animation extends Component {
    componentDidMount(){
        this.props.getSelectedTerm();
    }

    render(){
        let thisTerm, thisLevel;
        if (!this.props.selectedTerm || this.props.selectedTerm.termName === ""){
            thisTerm = "";
            thisLevel='0';
            return (
                <div className="animation-div"></div>
            );
        } else {
            thisTerm = this.props.selectedTerm.file_resource;
            thisLevel = this.props.selectedTerm.age_group;
        }
        let thisAnimUrl = `${this.props.baseUrl}/html-animations/level${thisLevel}/${thisTerm}.html`;

        return(
            <div className="animation-div">

                <iframe id="animationIframe"
                        scrolling="no"
                        className="animation-iframe"
                        src={thisAnimUrl}>

                </iframe>

            </div>

        );
    }
}


function mapStateToProps(state){
    return {
        selectedTerm: state.mathsDictionary.selectedTerm,
        baseUrl: state.mathsDictionary.baseUrl
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSelectedTerm
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Animation);
